import React, { Component } from 'react';
import classNames from 'classnames';
import Masonry from 'react-masonry-component';

import { firebaseDB } from '../firebase';


const masonryOptions = {
    transitionDuration: 0
};

class Gallery extends Component {
    constructor(props) {
        super(props);

        this.state = {
            images: [],
            filter: '*'
        }

        this.imagesDBRef = firebaseDB.ref('/site-images').orderByChild('sortRating');
    }

    componentDidMount() {
        this.imagesDBRef.on("child_added", (snapshot) => {
            this.setState((prevState, props) => ({
                images: [
                    ...prevState.images,
                    {
                        key: snapshot.key,
                        largeURL: snapshot.val().largeURL,
                        thumbURL: snapshot.val().thumbURL,
                        title: snapshot.val().title,
                        categories: snapshot.val().categories
                    }
                ]
            }));
        });
    }

    componentWillUnmount() {
        this.imagesDBRef.off();
    }

    filterChange(filter = '*', e) {
        e.preventDefault();

        this.setState({
            filter: filter
        });
    }

    enablePopup() {
        window.galleryPopup();
    }

    renderImagesItem(key, largeURL = "", thumbURL = "", title = "...") {
        return (
            <div key={key} className="portfolio-item">
                <div className="thumb action-btn">
                    <a href={largeURL} className="popup-gallery" title={title}>
                        <img src={thumbURL} alt="bianka" />
                    </a>
                </div>
            </div>
        );
    }

    renderImages() {
        return this.state.images.map((img) => {
            if (this.state.filter === '*' || (img.categories && img.categories.includes(this.state.filter))) {
                return this.renderImagesItem(img.key, img.largeURL, img.thumbURL, img.title)
            }
            return '';
        });
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="heading-title text-center">
                        <h3 className="text-uppercase">Portfolio</h3>
                        <p className="half-txt p-top-30">Nasze projekty to nasza najważniesza wizytówka. Jesteśmy dumni z naszej pracy, w której
                                znajdziesz mnóstwo serca. Tutaj prezentujemy zaledwie niewielką część spośród setek naszych
                                prac.</p>
                    </div>

                    <div className="text-center">
                        <ul className="portfolio-filter">
                            <li className={classNames({ 'active': this.state.filter === '*' })}>
                                <a href="#" onClick={this.filterChange.bind(this, '*')}> Wszystkie</a>
                            </li>
                            <li className={classNames({ 'active': this.state.filter === 'bukiet' })}>
                                <a href="#" onClick={this.filterChange.bind(this, 'bukiet')}>bukiety</a>
                            </li>
                            <li className={classNames({ 'active': this.state.filter === 'sala' })}>
                                <a href="#" onClick={this.filterChange.bind(this, 'sala')}>sale</a>
                            </li>
                            <li className={classNames({ 'active': this.state.filter === 'kosciol' })}>
                                <a href="#" onClick={this.filterChange.bind(this, 'kosciol')}>kościoły</a>
                            </li>
                            <li className={classNames({ 'active': this.state.filter === 'samochod' })}>
                                <a href="#" onClick={this.filterChange.bind(this, 'samochod')}>samochody</a>
                            </li>
                            <li className={classNames({ 'active': this.state.filter === 'poligrafia' })}>
                                <a href="#" onClick={this.filterChange.bind(this, 'poligrafia')}>poligrafia</a>
                            </li>
                            <li className={classNames({ 'active': this.state.filter === 'dodatki' })}>
                                <a href="#" onClick={this.filterChange.bind(this, 'dodatki')}>dodatki</a>
                            </li>
                        </ul>
                    </div>

                    <Masonry
                        className={'portfolio portfolio-masonry col-4 gutter'}
                        elementType={'div'}
                        options={masonryOptions}
                        disableImagesLoaded={false}
                        updateOnEachImageLoad={false}
                        onLayoutComplete={this.enablePopup}
                    >
                        {this.renderImages()}
                    </Masonry>
                </div>
            </div>
        );
    }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/gallery/Gallery.js